module.exports = "<div>\r\n  <p><span>{{model.confirmationMessage}}</span></p>\r\n  <div class=\"button-row\">\r\n    <button class=\"btn btn-outline-dark button\" type=\"button\" (click)=\"onCancel()\">Close</button>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/sponsor-dealer-confirmation/sponsor-dealer-confirmation.component.html
// module id = ./src/app/shared/components/sponsor-dealer-confirmation/sponsor-dealer-confirmation.component.html
// module chunks = main